import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { GerenciarForm } from "../modais"
import Layout from "../Layout"
class ContratosManageForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <GerenciarForm callBackGerenciar={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratosManageForm)



// WEBPACK FOOTER //
// ./src/views/contratos/ContratosManageForm.js